import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { List, ListItem, ListItemButton, ListItemIcon, ListItemText, ListSubheader, Typography } from "@mui/material";
import { Download } from "@mui/icons-material";

const INDIVIDUAL_FORMS = [
  {
    labelKey: "offlineForms.individual",
    file: "Individual_WebForm_TaxVer.5.1.1.2.pdf"
  }
];

const ORGANIZATION_FORMS = [
  {
    labelKey: "offlineForms.organization.generalAviation",
    file: "GENERAL_AVIATION_Webform_TaxVer.5.1.1.2.pdf"
  },
  {
    labelKey: "offlineForms.organization.flightOperations",
    file: "FLIGHT_OPERATIONS_Webform_TaxVer.5.1.1.2.pdf"
  },
  {
    labelKey: "offlineForms.organization.atmAns",
    file: "ATM___ANS_Webform_TaxVer.5.1.1.2.pdf"
  },
  {
    labelKey: "offlineForms.organization.aerodrome",
    file: "AERODROME_GENERAL_Webform_TaxVer.5.1.1.2.pdf"
  }
];

const OfflineFormsDownload = () => {
  const { t, i18n } = useTranslation();

  return (
    <>
      <Typography variant="h6">{t("offlineForms.title")}</Typography>
      <Typography variant="body2">
        <Trans
          i18nKey="offlineForms.description"
          components={{
            // eslint-disable-next-line
            a: (
              <a
                href={`https://get.adobe.com/${i18n.language === "cs" ? "cz/" : ""}reader/`}
                target="_blank"
                rel="noopener noreferrer"
              />
            )
          }}
        />
      </Typography>
      <List sx={{ maxWidth: 400, width: "100%" }}>
        {INDIVIDUAL_FORMS.map((f) => (
          <ListItem key={f.labelKey}>
            <ListItemButton href={`templates/${i18n.language}/${f.file}`} download={f.file}>
              <ListItemIcon>
                <Download />
              </ListItemIcon>
              <ListItemText>{t(f.labelKey)}</ListItemText>
            </ListItemButton>
          </ListItem>
        ))}
        <ListSubheader>{t("offlineForms.organization.title")}</ListSubheader>
        {ORGANIZATION_FORMS.map((f) => (
          <ListItem key={f.labelKey}>
            <ListItemButton href={`templates/${i18n.language}/${f.file}`} download={f.file}>
              <ListItemIcon>
                <Download />
              </ListItemIcon>
              <ListItemText>{t(f.labelKey)}</ListItemText>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </>
  );
};

export default OfflineFormsDownload;
